import { gql, useQueryWithPreviousData } from "@outschool/ui-apollo";

const canReviewUpcomingMeetingQuery = gql`
  query CanReviewUpcomingMeeting($sectionUid: ID!) {
    canReviewUpcomingMeeting(sectionUid: $sectionUid)
  }
`;

export default function useCanReviewUpcomingMeeting(sectionUid: string | null) {
  const { data, loading } = useQueryWithPreviousData(
    canReviewUpcomingMeetingQuery,
    {
      variables: { sectionUid },
      skip: !sectionUid,
    },
  );

  return !loading && data?.canReviewUpcomingMeeting;
}
